import { type MarkerObject as MapMarkerObject, MapStyle } from '../../../../common/types';
import CanvasObject from '../CanvasObject';
import type SurfaceBase from '../SurfaceBase';
import type { Point } from '../SurfaceBase';
import { markerBboxPadding, markerLineWidth, markerRadius } from './common';

export default class MarkerObject extends CanvasObject {
  marker: MapMarkerObject;

  private point: Point;

  constructor(id: string, surface: SurfaceBase, marker: MapMarkerObject) {
    super(id, surface);
    this.marker = marker;
    this.point = this.surface.toScreenCoords({
      lng: marker.geometry.coordinates[0],
      lat: marker.geometry.coordinates[1],
    });
  }

  refreshScreenCoords(): void {
    this.point = this.surface.toScreenCoords({
      lng: this.marker.geometry.coordinates[0],
      lat: this.marker.geometry.coordinates[1],
    });
  }

  drawHitArea(ctx: OffscreenCanvasRenderingContext2D, color: string): void {
    ctx.strokeStyle = color;
    ctx.fillStyle = color;
    ctx.lineWidth = markerLineWidth;
    ctx.beginPath();
    // hit area is twice the radius
    ctx.arc(this.point.x, this.point.y, markerRadius * 2, 0, 2 * Math.PI);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
  }

  render(ctx: CanvasRenderingContext2D): void {
    const store = this.getStore();
    const { title, properties } = this.marker;
    ctx.beginPath();
    ctx.globalAlpha = 1;
    ctx.strokeStyle = 'white';
    ctx.fillStyle = properties.color;
    ctx.lineWidth = markerLineWidth;
    ctx.arc(this.point.x, this.point.y, markerRadius, 0, 2 * Math.PI);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();

    ctx.lineWidth = 0.5;

    if (
      !store.currentMap.isLoading &&
      (store.currentMap.baseMap === MapStyle.satellite || store.currentMap.baseMap === MapStyle.dark)
    ) {
      ctx.strokeStyle = 'black';
      ctx.fillStyle = 'white';
    } else {
      ctx.strokeStyle = 'white';
      ctx.fillStyle = 'black';
    }

    ctx.font = 'bold 1.2rem sans-serif';
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'start';
    ctx.fillText(title, this.point.x + markerBboxPadding, this.point.y);
    ctx.strokeText(title, this.point.x + markerBboxPadding, this.point.y);
  }
}
